import { AccordionLink } from '../../components/AccordionLink';
import { Button } from '../../components/Button';
import { ExpandableText } from '../../components/ExpandableText';
import { FromPriceDisplay } from '../../components/PriceDisplay';
import { SkeletonBlock } from '../../components/SkeletonBlock';
import {
  ButtonSection,
  CategoryLabel,
  DescriptionSection,
  HeaderGroup,
  ScrollArea,
  Spacer,
  TermsSection,
  Title,
  Wrapper,
} from './ContentPanel.styles';
import type { ContentPanelProps } from './ContentPanel.types';

export function ContentPanel({
  title,
  price,
  priceLabel = 'from',
  categoryLabel,
  description,
  termsContent,
  termsLabel = 'Terms & Conditions',
  onReserve,
  reserveLabel = 'Reserve',
  isLoading = false,
}: ContentPanelProps) {
  if (isLoading) {
    return (
      <Wrapper>
        <ScrollArea>
          <HeaderGroup>
            <SkeletonBlock variant="heading" />
            <SkeletonBlock width="35%" height="1.25rem" />
          </HeaderGroup>
          <Spacer />
          <CategoryLabel as="div">
            <SkeletonBlock width="25%" height="0.875rem" />
          </CategoryLabel>
          <DescriptionSection>
            <SkeletonBlock variant="text" />
            <SkeletonBlock variant="text" />
            <SkeletonBlock variant="text" width="70%" />
          </DescriptionSection>
          <Spacer />
          <TermsSection>
            <SkeletonBlock height="48px" />
          </TermsSection>
        </ScrollArea>
        <ButtonSection>
          <SkeletonBlock variant="button" />
        </ButtonSection>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <ScrollArea>
        <HeaderGroup>
          <Title>{title}</Title>
          {price && (
            <FromPriceDisplay
              amount={price.amount}
              currencyCode={price.currencyCode}
              label={priceLabel}
            />
          )}
        </HeaderGroup>
        <Spacer />
        {categoryLabel && <CategoryLabel>{categoryLabel}</CategoryLabel>}
        {description && (
          <DescriptionSection>
            <ExpandableText text={description} />
          </DescriptionSection>
        )}
        <Spacer />
        {termsContent && (
          <TermsSection>
            <AccordionLink label={termsLabel}>{termsContent}</AccordionLink>
          </TermsSection>
        )}
      </ScrollArea>
      {onReserve && (
        <ButtonSection>
          <Button variant="primary" fullWidth onClick={onReserve}>
            {reserveLabel}
          </Button>
        </ButtonSection>
      )}
    </Wrapper>
  );
}
